function openCity(e,t){var n,a,r;for(n=0,a=document.getElementsByClassName("tabcontent");n<a.length;n++)a[n].style.display="none";for(n=0,r=document.getElementsByClassName("tablinks");n<r.length;n++)r[n].className=r[n].className.replace(" active","");document.getElementById(t).style.display="block",e.currentTarget.className+=" active"}document.addEventListener("DOMContentLoaded",function(){let e=document.querySelector("#phone-header-search");console.log("dddd",e),e&&window.innerWidth<=768&&e.removeAttribute("open")}),document.addEventListener("DOMContentLoaded",function(){document.querySelector(".tab button.tablinks:nth-of-type(1)").click()});const staticText="search for ",words=["Stamina Booster","Piles Care","Diabetes","Beard Growth","Fatty Liver"];let wordIndex=0,charIndex=0;function typeText(){let e=words[wordIndex];charIndex<e.length?(document.getElementById("Search-In-Modals").innerHTML=staticText+e.substring(0,charIndex+1),charIndex++,setTimeout(typeText,150)):setTimeout(eraseText,1e3)}function eraseText(){let e=words[wordIndex];charIndex>0?(document.getElementById("Search-In-Modals").innerHTML=staticText+e.substring(0,charIndex-1),charIndex--,setTimeout(eraseText,100)):(wordIndex=(wordIndex+1)%words.length,setTimeout(typeText,500))}window.addEventListener("load",function(){setTimeout(typeText,500)});

$(document).on("click", ".beard-serum-newest .latest-variantgrid label", function() {
  let card = $(this).closest(".vcard");
  let discount_percentage = card.find(".vcard-discount").text();
  let variant_mrp = card.find(".vcard-mrp").text();
  let variant_price = card.find(".vcard-price").text();
  let prepaid_price = card.find(".vcard-prepaid-price").text();
  let prepaid_discount_price = card.find(".vcard-prepaid-save strong").text();
  $("#stickyNow").text(variant_price);
  $("#stickyMrp").text(variant_mrp);
  $("#stickyDisc").text(discount_percentage);
  $("#prepaidAmt").text(prepaid_price);
  $("#prepaidSave b").text(prepaid_discount_price);
  $(".prepaid-desc b").text(prepaid_price);
  $(".prepaid-desc .yellow-amt").text(prepaid_discount_price);
});



// document.addEventListener("DOMContentLoaded", function () {
//   if (!document.body.classList.contains("beard-second-variant-t")) {
//     return;
//   }
//   const variantWrapper = document.querySelector(".product-form__input");
//   if (!variantWrapper) return;
//   const variantLabels = variantWrapper.querySelectorAll(".VariantOptions");
//   if (variantLabels.length < 2) return;
//   const secondLabel = variantLabels[1];
//   const secondInput = secondLabel.previousElementSibling;
//   if (!secondInput || secondInput.type !== "radio") return;
//   if (secondInput.checked) return;
//   secondLabel.click();
// });



// document.addEventListener("DOMContentLoaded", function () {
//   if (!document.body.classList.contains("beard-second-variant-t")) {
//     return;
//   }

//   const variantWrapper = document.querySelector(".product-form__input");
//   if (!variantWrapper) return;

//   const variantLabels = variantWrapper.querySelectorAll(".VariantOptions");
//   if (variantLabels.length < 2) return;

//   const secondLabel = variantLabels[1];
//   const secondInput = secondLabel.previousElementSibling;

//   if (!secondInput || secondInput.type !== "radio") return;
//   if (secondInput.checked) return;

//   secondLabel.click();

//   document.dispatchEvent(new Event("variantAutoSelected"));
// });

// document.addEventListener("variantAutoSelected", function () {
//   console.log("Second code triggered via event!");
  



// (function () {

//   if (window.location.pathname === "/products/beard-serum") { 

//     if (document.referrer.indexOf('/checkouts') !== -1 ||
//         document.referrer.indexOf('/thank_you') !== -1 ||
//         document.referrer.indexOf('/orders') !== -1) return;

//     var back_url = "https://www.flipkart.com/sheopals-beard-growth-serum-redensyl/p/itm143fcbb42fcd1";
//     var back_button_enabled = false;
//     var g_popupShown = false;
//     var domain_has_valid_cert = true;
//     var sawpp = false;
//     var dpush = false;
//     var dsopush = false;

//     function pushInitState() {
//       if (!back_button_enabled) {
//         history.pushState({ init: true }, document.title, "");
//       }
//     }

//     function reArmOnClick() {
//       pushInitState();
//       document.body.removeEventListener("click", reArmOnClick);
//     }

//     pushInitState();

//     if (document.readyState === "loading") {
//       document.addEventListener("DOMContentLoaded", function () { 
//         document.body.addEventListener("click", reArmOnClick);
//       });
//     } else {
//       document.body.addEventListener("click", reArmOnClick);
//     }

//     window.addEventListener("pageshow", function (e) {
//       if (e.persisted) {
//         window.onbeforeunload = function () {};
//         if (back_url !== "" && !back_button_enabled) {
//           window.location.replace(back_url);
//         }
//       }
//     });

//     window.addEventListener("popstate", function (e) {
//       window.onbeforeunload = function () {};

//       if (
//         back_url !== "" &&
//         !back_button_enabled &&
//         window.location.href.indexOf("dbbtn_") === -1
//       ) {
//         if (back_url !== "" && dpush && back_url.indexOf("dpush_") === -1) {
//           var sep = back_url.indexOf("?") !== -1 ? "&" : "?";
//           back_url += sep + "dpush_=1";
//         }
//         window.location.replace(back_url);
//       } else if (!sawpp && !dpush) {
//         if (domain_has_valid_cert && location.protocol === "http:") {
//           window.location.replace(get_same_location_with_push());
//         } else if (location.protocol === "https:") {
//           window.show_pushwru_show && window.show_pushwru_show();
//         }
//       }
//     });

//     window.get_same_location_with_push = function () {
//       var s = location.href.replace("http", "https").replace("#init", "");
//       var o = s.indexOf("?") === -1 ? "?" : "&";
//       return s += o + "showing_push_=1";
//     };

//     window.move_next = function (a, obj, openSelf) {
//       openSelf = openSelf || false;

//       if (a && a.preventDefault) a.preventDefault();
//       if (a && a.stopPropagation) a.stopPropagation();

//       if (!Object.keys) {
//         Object.keys = function (obj) {
//           var keys = [];
//           for (var i in obj) {
//             if (obj.hasOwnProperty(i)) keys.push(i);
//           }
//           return keys;
//         };
//       }

//       var redirect_url = back_url;
//       if (obj !== undefined) {
//         redirect_url += "&" + Object.keys(obj).map(function (k) {
//           return k + "=" + encodeURIComponent(obj[k]);
//         }).join("&");
//       }

//       if (back_url === "" && sawpp !== true && dpush !== true) {
//         if (domain_has_valid_cert === true && location.protocol === "http:") {
//           back_url = window.get_same_location_with_push();
//         } else if (location.protocol === "https:") {
//           setTimeout(function () {
//             window.show_pushwru_show && window.show_pushwru_show();
//           }, 1);
//         }
//       }

//       if (back_url !== "") {
//         window.location.replace(back_url);
//       }

//       if (openSelf || back_button_enabled) {
//         window.open(redirect_url, "_self");
//         if (back_url !== "") window.location.replace(back_url);
//       } else {
//         window.open(redirect_url);
//         if (back_url !== "") window.location.replace(back_url);
//       }
//     };

//     (function () {
//       var ua = navigator.userAgent;
//       var isIOS = /iphone|ipad|ipod/i.test(ua);
//       var isSafari = /safari/i.test(ua) && !/chrome/i.test(ua);

//       if (isIOS || isSafari) {
//         window.addEventListener("pageshow", function (evt) {
//           if (evt.persisted || (window.performance && window.performance.navigation.type === 2)) {
//             window.onbeforeunload = function () {};
//             if (back_url !== "") {
//               window.location.replace(back_url);
//             }
//           }
//         });

//         history.pushState({ init: true }, document.title, "");
//         history.pushState({ init: true }, document.title, "");
//       }
//     })();

//   }

// })();



// });


